import React, { useEffect, useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import OTPInput from "react-otp-input";
import { LoginService } from "../api/Login";
import { useDispatch } from "react-redux";
import { setAuthData } from "../redux/actions/authActions";
import {
  setCurrentMembership,
  setProcessData,
} from "../redux/actions/processAction";
import { useNavigate } from "react-router-dom";
import { tostW } from "../config/tostConfig";
import { maskInput, removeNullValues } from "../utils/commonFunction";
import moment from "moment";

export default function Otp({ credentials, onBack }) {
  const [loading, setLoading] = useState(false);
  const [submittedOnce, setSubmittedOnce] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    otp: Yup.string().required("OTP is required"),
  });

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      if (loading) return;
      const body = {
        email_phone: credentials,
        otp: values.otp,
      };
      setLoading(true);
      try {
        const res = await LoginService(body);
        if (res.status === 200 && res.data.success) {
          const respData = res.data.data;
          if (respData.steps < 4) {
            dispatch(setCurrentMembership(respData.plan));
            dispatch(
              setProcessData({
                ...removeNullValues(respData.plan_history),
                ...removeNullValues(respData),
                email_verified: true,
                mobile: respData.mobile_number,
                mobile_verified: true,
                incorporation_date: respData?.incorporation_date
                  ? respData.incorporation_date
                  : respData?.org_type === "company"
                  ? moment(respData?.company?.incorporation_date).format(
                      "YYYY-MM-DD"
                    )
                  : respData.org_type === "partnership"
                  ? moment(respData?.llp?.incorporation_date).format(
                      "YYYY-MM-DD"
                    )
                  : "",
              })
            );
            navigate("/register/user/membership-form", { replace: true });
          } else if (
            !respData.membership_id &&
            respData.plan_history &&
            respData.plan_history.approval_governing_1 !== 1 &&
            respData.plan_history.approval_governing_2 !== 1
          ) {
            navigate(
              "/register/user/application-review/" +
                btoa(respData.plan_history.app_id),
              { replace: true }
            );
          } else if (
            !respData.membership_id &&
            respData.plan_history &&
            respData.plan_history.payment_status !== 1
          ) {
            navigate(
              "/register/user/checkout/" + btoa(respData.plan_history.app_id),
              { replace: true }
            );
          } else {
            const token = res.data.token;
            dispatch(setAuthData(token, respData));
          }
        } else {
          tostW(res.data.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (!submittedOnce) {
          setSubmittedOnce(true);
        }
        setLoading(false);
      }
    },
  });

  const { values, touched, errors, setFieldValue, handleSubmit } = formik;

  useEffect(() => {
    if (!submittedOnce && values.otp.length === 4) {
      handleSubmit();
    }
  }, [values.otp]); // eslint-disable-line

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={handleSubmit}>
        <div className="d-flex align-items-center flex-column mb-3">
          <label htmlFor="emailOrMobile">
            OTP has been sent to {maskInput(credentials)}
          </label>
          <OTPInput
            value={values.otp}
            onChange={(otp) => {
              setFieldValue("otp", otp);
            }}
            renderInput={(props) => (
              <div className="form-group">
                <input {...props} />
              </div>
            )}
            containerStyle={"optInputGroups"}
            inputStyle={"form-control"}
            shouldAutoFocus
            placeholder="----"
            inputType="number"
          />
          {errors.otp && touched.otp && (
            <small className="text-danger">{errors.otp}</small>
          )}
        </div>
        <div className="text-center">
          <button
            disabled={loading}
            className="btn back btn-primary mx-2"
            type="button"
            onClick={() => onBack()}
          >
            Back
          </button>
          {submittedOnce && (
            <button
              type="submit"
              className="btn btn-primary mx-2"
              disabled={loading}
            >
              Log In
            </button>
          )}
        </div>
      </Form>
    </FormikProvider>
  );
}
